import { MAX_IMPORT_FILES } from "../model/administrationConstants";
import { downloadImportReport, importReportSummary } from "../model/administrationReport";
import { primaryButtonStyle, secondaryButtonStyle } from "../styles/administrationModalStyles";
import {
    importControlsStyle,
    importIssuesStyle,
    importPanelStyle,
    importReportStyle,
    inputStyle,
    labelStyle,
} from "../styles/administrationStyles";

export function renderImportPanel(view) {
    const { importFiles, importReport, importWorkbook, importing, isSuperAdmin, setError, setImportFiles, setImportMode, setImportReport } = view;
    if (!isSuperAdmin) return null;
    return (
        <div style={importPanelStyle}>
            <div>
                <h2 style={{ margin: 0, fontSize: "18px", color: "#111827" }}>Importer le tableau Excel</h2>
                <p style={{ margin: "4px 0 0", color: "#64748b", fontSize: "13px" }}>
                    Importez un classeur .xlsx ou un dossier de tableurs nommé « Code EHPAD - Nom complet ». La feuille CREDIT EHPADS est ignorée.
                </p>
            </div>
            <div style={importControlsStyle}>
                <label style={labelStyle}>
                    <span>Fichier .xlsx</span>
                    <input
                        type="file"
                        accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        onChange={event => {
                            const files = Array.from(event.target.files || []);
                            setImportMode("file");
                            setImportFiles(files.slice(0, 1));
                            setImportReport(null);
                            setError("");
                        }}
                        style={{ ...inputStyle, minWidth: "280px" }}
                    />
                </label>
                <label style={labelStyle}>
                    <span>Dossier de tableurs</span>
                    <input
                        type="file"
                        accept=".xlsx,.xlsm,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        multiple
                        webkitdirectory=""
                        onChange={event => {
                            const files = Array.from(event.target.files || [])
                                .filter(file => /\.(xlsx|xlsm|xls)$/i.test(file.name));
                            if (files.length > MAX_IMPORT_FILES) {
                                setImportMode("folder");
                                setImportFiles([]);
                                setImportReport(null);
                                setError(`Le dossier contient ${files.length} tableur(s). Maximum autorisé : ${MAX_IMPORT_FILES}.`);
                                return;
                            }
                            setImportMode("folder");
                            setImportFiles(files);
                            setImportReport(null);
                            setError("");
                        }}
                        style={{ ...inputStyle, minWidth: "280px" }}
                    />
                </label>
                {importFiles.length > 0 && (
                    <span style={{ color: "#64748b", fontSize: "13px", fontWeight: 700 }}>
                        {importFiles.length} fichier(s) sélectionné(s)
                    </span>
                )}
                <button type="button" disabled={importing || importFiles.length === 0} onClick={() => importWorkbook(true)} style={secondaryButtonStyle}>
                    {importing ? "Traitement…" : "Contrôler"}
                </button>
                <button type="button" disabled={importing || importFiles.length === 0} onClick={() => importWorkbook(false)} style={primaryButtonStyle}>
                    {importing ? "Import…" : "Importer"}
                </button>
            </div>
            {importReport && (
                <div role="status" style={importReportStyle}>
                    <strong>{importReportSummary(importReport)}</strong>
                    <span>
                        {importReport.sheetsRead} feuille(s) lue(s), {importReport.issues?.length || 0} alerte(s)/erreur(s).
                    </span>
                    {importReport.applied && (
                        <span style={{ color: "#166534" }}>
                            Les données importées sont disponibles dans les vues Collectivités et Tuteur Curateur.
                        </span>
                    )}
                    {importReport.dryRun && importReport.rowsReady > 0 && (
                        <div>
                            <button
                                type="button"
                                disabled={importing || importFiles.length === 0}
                                onClick={() => importWorkbook(false)}
                                style={primaryButtonStyle}
                            >
                                Importer les {importReport.rowsReady} ligne(s) prête(s)
                            </button>
                        </div>
                    )}
                    {importReport.issues?.length > 0 && (
                        <>
                            <ul style={importIssuesStyle}>
                                {importReport.issues.slice(0, 8).map((issue, index) => (
                                    <li key={`${issue.sheet || "classeur"}-${issue.row || index}-${index}`}>
                                        <strong>{issue.severity}</strong>
                                        {issue.sheet && ` — ${issue.sheet}`}
                                        {issue.row && ` ligne ${issue.row}`}
                                        {" : "}{issue.message}
                                    </li>
                                ))}
                                {importReport.issues.length > 8 && <li>… {importReport.issues.length - 8} autre(s) point(s) dans le rapport.</li>}
                            </ul>
                            <div>
                                <button
                                    type="button"
                                    onClick={() => downloadImportReport(importReport)}
                                    style={secondaryButtonStyle}
                                >
                                    Télécharger le rapport CSV
                                </button>
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}
